import React from 'react';
import { Row, Col, Alert, Button } from 'reactstrap';
import { Translate, translate, Storage } from 'react-jhipster';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { IRootState } from 'app/shared/reducers';
import { connect } from 'react-redux';
import { handleAddSim, handleAddToken, reset } from '../user.reducer';
import MessageModal from 'app/shared/message/message-modal';
import { IND, ENP, SUCCESS, ORG } from 'app/config/constants';

export interface ICertInfoModalProps extends StateProps, DispatchProps {
  modalShow: boolean;
  handleClose: Function;
}

export interface ICertInfoModalState {
  //certInfo: any;
  visible: boolean;
  color: string;
  message: string;
  showMessage: boolean;
  checkFirst: boolean;
  txtEmail: string;
  disableButtonReg: boolean;
}
export class CertInfoModal extends React.Component<ICertInfoModalProps, ICertInfoModalState> {
  state: ICertInfoModalState = {
    //certInfo: {},
    visible: false,
    color: 'danger',
    message: '',
    showMessage: false,
    checkFirst: true,
    txtEmail: '',
    disableButtonReg: false
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.response !== nextProps.response) {
      const { response } = nextProps;
      if (response && response.status === 'SUCCESS') {
        this.removeAllStorage();
        this.setState({
          disableButtonReg: false,
          showMessage: true
        });
        let timerId = setTimeout(() => {
          this.setState({
            showMessage: false
          });
        }, 2000);
        window['showHideModal']('hide');
      } else if (response && response.status) {
        this.setState({
          disableButtonReg: false,
          visible: true,
          color: 'danger',
          message: response.message && response.message !== 'ERROR' ? response.message : translate('register.messages.error.addfail')
        });
      }
    }

    if (nextProps.regTokenFailure) {
      const userType = this.props.userProfile.userType;
      this.setState({
        disableButtonReg: false,
        showMessage: false,
        visible: true,
        color: 'danger',
        message:
          userType === IND
            ? 'Không tìm thấy thông tin cá nhân tại cơ sở dữ liệu của Ban Cơ yếu, vui lòng liên hệ với đầu mối của Ban Cơ yếu để kiểm tra!'
            : userType === ORG
            ? 'Không tìm thấy thông tin tổ chức tại cơ sở dữ liệu của Ban Cơ yếu, vui lòng liên hệ với đầu mối của Ban Cơ yếu để kiểm tra!'
            : 'Bạn đang dùng chứng thư số của Ban Cơ yếu vui lòng chọn chứng thư đúng để đăng ký doanh nghiệp!'
      });
    }
  }

  componentWillUnmount() {
    this.props.reset();
  }

  handleValidSubmit = (event, values) => {
    const type = Storage.session.get('type');
    const userType = this.props.userProfile.userType; //Storage.session.get('userType');
    if (type && type === 'Token') {
      const certInfo = Storage.session.get('certInfo');
      const signed = Storage.session.get('singed');
      const otp = Storage.session.get('totp');
      this.props.handleAddToken(signed, certInfo.base64, otp, userType, values.email);
    } else {
      const certInfo = this.props.infoCert;
      const provider = Storage.session.get('provider');
      this.props.handleAddSim(certInfo.cert, userType, this.state.txtEmail, certInfo.phone, provider);
    }
    this.setState({ disableButtonReg: true });
  };

  removeAllStorage = () => {
    Storage.session.remove('type');
    //Storage.session.remove('userType');
    Storage.session.remove('singed');
    Storage.session.remove('totp');
    Storage.session.remove('certInfo');
  };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  render() {
    //let certInfo = Storage.session.get('certInfo');
    const userType = this.props.userProfile.userType;
    const type = Storage.session.get('type');
    let certInfo;
    let userName = 'Họ tên';
    if (userType === ENP) {
      userName = 'Tên doanh nghiệp';
    }
    if (userType === ORG) {
      userName = 'Tên tổ chức';
    }
    if (type && type === 'Token') {
      certInfo = Storage.session.get('certInfo');
    } else {
      certInfo = this.props.infoCert;
    }
    return (
      <div>
        <MessageModal type={SUCCESS} showModal={this.state.showMessage} message={'Chúc mừng bạn đã thêm thành công.'} />
        <div
          className="modal fade hide-border-bottom-modal"
          id="modalCertInfo"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-scrollable" role="document">
            <div className="modal-content">
              <div className="modal-header" style={{ margin: '0 auto' }}>
                <Row>
                  <Col md="12">
                    <h2 className="text-center font-weight-bold" id="register-title">
                      {/* <Translate contentKey="register.title">Registration</Translate> */}
                      Đăng ký
                    </h2>
                    <p className="text-center txtContent">
                      <Translate contentKey="register.txtContent" />
                    </p>
                  </Col>
                </Row>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    window['showHideModal']('hide');
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body bodyModal" style={{ paddingTop: '0' }}>
                <Row className="justify-content-center">
                  <Alert id="myAlert" color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
                    {this.state.message}
                  </Alert>
                  <Col md="12">
                    <AvForm id="formCertInfo" onValidSubmit={this.handleValidSubmit}>
                      {/* <input type="hidden" id="totp" name="totp" value={totp} />
              <input type="hidden" id="userType" name="userType" value={userType} />
              <input type="hidden" id="cert" name="cert" value={certInfo ? certInfo.cert : ''} /> */}
                      {/* {userType && userType === ENP ? (
                        <AvField
                          name="identity"
                          label="Mã số thuế" //{translate('global.form.tax.label')}
                          value={certInfo ? certInfo.uid : ''}
                          readOnly
                        />
                      ) : (
                        <AvField
                          name="identity"
                          label="Số chứng minh thư" //{translate('global.form.identity.label')}
                          value={certInfo ? certInfo.uid : ''}
                          readOnly
                        />
                      )} */}

                      <AvField
                        name="fullName"
                        label={userName} //{translate('global.form.name.label')}
                        value={certInfo ? certInfo.subjectCN : ''}
                        readOnly
                      />

                      <AvField
                        name="fromDate"
                        label="Ngày hiệu lực" //{translate('global.form.fromDate.label')}
                        value={certInfo ? certInfo.notBefore : ''}
                        readOnly
                      />
                      <AvField
                        name="toDate"
                        label="Ngày hết hạn" //{translate('global.form.toDate.label')}
                        value={certInfo ? certInfo.notAfter : ''}
                        readOnly
                      />
                      <AvField
                        name="nameCA"
                        label="Tên CA" //{translate('global.form.nameCA.label')}
                        value={certInfo ? certInfo.issuerCN : ''}
                        readOnly
                      />
                      <AvField
                        name="email"
                        label="Email" //{translate('global.form.email.label')}
                        placeholder={translate('global.form.email.placeholder')}
                        type="email"
                        value={certInfo ? certInfo.Email : ''}
                        validate={{
                          required: { value: true, errorMessage: translate('register.messages.validate.email.required') },
                          maxLength: { value: 250, errorMessage: translate('global.messages.validate.email.maxlength') },
                          email: { value: true, errorMessage: translate('register.messages.validate.email.pattern') }
                        }}
                      />
                      <Button className="btn-register" type="submit" disabled={this.state.disableButtonReg} block>
                        Đăng ký
                        {/* <Translate contentKey="register.form.button">Register</Translate> */}
                      </Button>
                    </AvForm>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        {type && type === 'Token' ? window['setValFormCertInfo']() : null}
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  response: storeState.userInfo.response,
  infoCert: storeState.register.infoCert,
  userProfile: storeState.userInfo.userProfile,
  regTokenFailure: storeState.register.regTokenFailure
});

const mapDispatchToProps = { handleAddSim, handleAddToken, reset };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CertInfoModal);
